export default __webpack_public_path__ + "static/kacper_hb-cffdfa7fa49deeeee6a89ca3d3fb766f.webp";